import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "antd";
import { Link } from "react-router-dom";

const renderAvatar = (props) => {
  return (
    <Avatar {...props} className={`ant-avatar-${props.type}`}>
      {props.text}
    </Avatar>
  );
};

export const AvatarStatus = (props) => {
  const { name, suffix, subTitle, id, type, src, icon, size, shape, gap, text, linkTo } = props;
  return (
    <div className="avatar-status d-flex align-items-center">
      {renderAvatar({ icon, src, type, size, shape, gap, text })}
      <div className="ml-2">
        <div>
          {linkTo ? (
            <Link to={linkTo} className="avatar-status-name clickable" style={{ marginLeft: 6 }}>
              {name}
            </Link>
          ) : (
            <div className="avatar-status-name" style={{ marginLeft: 6 }}>
              {name}
            </div>
          )}
          <span>{suffix}</span>
        </div>
        <div className="text-muted avatar-status-subtitle"  style={{ marginLeft: 6 }}>{subTitle}</div>
      </div>
    </div>
  );
};

AvatarStatus.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  type: PropTypes.string,
  onNameClick: PropTypes.func,
};

export default AvatarStatus;
